import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import questions from '../../../survey/questions';
import download from './img/download.png';
import s from './map.module.scss';

let animation = null;

function randomInteger (min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

function Map (data) {
	const units = questions.getAnswers({
		questionName: 'weight'
	}).units.value;
	const currentStep = useSelector((state) => state.steps.currentStep);

	useEffect(() => {
		const dots = document.querySelectorAll(`.${s.dots} g circle`);
		const dotsGroup = document.querySelectorAll(`.${s.dots} g`);
		const dotsGroupCount = dotsGroup.length;

		dots.forEach((dot) => {
			const x = dot.getAttribute('cx');
			const y = dot.getAttribute('cy');

			dot.style.setProperty('--cx', `${x}px`);
			dot.style.setProperty('--cy', `${y}px`);
		});

		dotsGroup.forEach((dotGroup) => {
			dotGroup.addEventListener('animationend', (e) => {
				e.currentTarget.classList.remove(`${s.animate}`);
			});
		});

		function getRandomIntInclusive (min, max) {
			min = Math.ceil(min);
			max = Math.floor(max);
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}

		animation = setInterval(() => {
			const groupNumber = getRandomIntInclusive(1, dotsGroupCount);
			if (dotsGroup[groupNumber]) dotsGroup[groupNumber].classList.add(`${s.animate}`);

			if (dotsGroup[groupNumber]) {
				dotsGroup[groupNumber].querySelector('text').innerHTML = `-${randomInteger(1, 12)} ${units}`;
			}
		}, 800);

		if (!data.data.isThisCurrentStep && !data.data.isThisNextStep) {
			animation && clearInterval(animation);
		}

		return () => {
			animation && clearInterval(animation);
		};
	}, [currentStep]);

	return (
		<svg className={s.map} viewBox="0 0 400 252" aria-hidden="true">
			<g transform="translate(.002 .197)" fill="none" fillRule="evenodd">
				<image x="-.002" y=".803" width="400" height="249.816" xlinkHref={download} />
				<g fill="#FFD400" opacity="1" className={s.dots}>
					<g transform="matrix(-1 0 0 1 205.453 103.864)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 213.418 106.935)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 203.683 106.935)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 194.998 112.803)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 224.038 99.258)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 186.867 79.298)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 197.998 91.803)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 208.998 86.803)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 243.51 86.975)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 222.268 109.238)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 250.59 86.975)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 252.36 80.066)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 249.704 99.258)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 323.161 113.844)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 321.391 98.49)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 328.472 59.339)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 319.621 114.611)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 298.38 113.844)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 301.036 114.611)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 354.998 185.803)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 346.172 179.864)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 118.72 106.935)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 99.25 92.349)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 102.79 96.187)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 153.236 169.884)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 111.64 152.995)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 118.72 153.763)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 101.905 106.935)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 100.135 77.763)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 78.01 77.763)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 80.664 69.318)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 60.309 64.712)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 80.664 114.611)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 85.974 116.914)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 128.456 93.884)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 111.64 111.54)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 77.124 94.652)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 206.998 116.803)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 128.456 205.197)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>

					<g transform="matrix(-1 0 0 1 196.998 118.803)">
						<circle cx=".5" cy=".535" r="1" />
						<circle cx=".5" cy=".535" r="1" />
						<text x="-30" y="-10" transform="matrix(-1 0 0 1 0 0)" className={s.text}>-1 kg</text>
					</g>
				</g>
			</g>
		</svg>
	);
}

export default Map;
